import React, { Component } from 'react';
import InventoryDeleteModal from './InventoryDeleteModal';
import Alert from '../../utils/Alert';
import PrintInventoryItem from './PrintInventoryItem'

export default class InventoryDetailHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      openDeleteModal: false,
      deleteMessage: '',
      categoryIndex: -1
    };

    this.alertRef = React.createRef();
  }

  openModal = (e) => {
    this.setState({
      openDeleteModal: true
    });
  };

  handleDeleteInventory = () => {
    if (this.state.categoryIndex > -1) {
      let waste_category = this.props.wasteCategoriesList[this.state.categoryIndex] ? this.props.wasteCategoriesList[this.state.categoryIndex].id : '';
      this.props.onInventoryDelete(this.props.inventory.id, this.state.deleteMessage, waste_category)
    } else {
      this.setState({openDeleteModal: false});
      this.alertRef.current.sendAlert("Error: Waste category can't be blank");
    }
  };

  handleDeleteMessageChange = (event) => {
    let deleteMessage = event.target.value
    this.setState({ deleteMessage })
  };

  onCategoryChange = (event) => {
    this.setState({ categoryIndex: event.target.value });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    return (
      <div className="card-header">
        <Alert ref={this.alertRef}/>

        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="text-align-center m-0 mr-05">Inventory #{this.props.inventory.id}</h4>
          </div>
          { this.props.editMode ?
            <div className="d-flex justify-content-end">
              <a className="btn btn-success color-white mr-05 hidden-xs-down" onClick={this.props.saveEditChanges}>Save</a>
              <a className="btn btn-danger color-white mr-0 hidden-xs-down" onClick={this.props.switchEditMode}>Cancel</a>
              <a className="btn btn-success color-white mr-05 hidden-sm-up" onClick={this.props.saveEditChanges}><i className="fa fa-save"></i></a>
              <a className="btn btn-danger color-white mr-0 hidden-sm-up" onClick={this.props.switchEditMode}><i className="fa fa-remove"></i></a>
            </div>
          :
          <div className="d-flex justify-content-end">
            {this.props.inventory.active && !this.props.inventory.item.is_barcode_item ? <a className="btn btn-primary color-white mr-05 m-0" onClick={this.props.switchEditMode}><i className="fa fa-edit"></i></a> : null}
            {!this.props.inventory.item.is_barcode_item && <PrintInventoryItem  inventory={this.props.inventory} />}
            {this.props.inventory.active && this.props.allowDelete ? <a className="btn btn-danger color-white mr-0 m-0" onClick={this.openModal}><i className="fa fa-trash"></i></a> : ''}
          </div>
          }
        </div>

        <InventoryDeleteModal
          header={"Remove from Inventory"}
          subtitle={'Waste category: '}
          // selectTitle={}
          closeModal={() => this.setState({openDeleteModal: false})}
          isModalOpen={this.state.openDeleteModal}
          onConfirm={this.handleDeleteInventory}
          onCancel={() => this.setState({openDeleteModal: false})}
          onSelectChange={this.onCategoryChange}
          disableOnConfirm={parseInt(this.state.categoryIndex, 0) === -1}
          list={this.props.wasteCategoriesList}
          value={this.state.categoryIndex}
          emptySelectMsg={'Select waste category'}
          textPlaceholder="Also, you can write the reason for removing this item (optional)..."
          textInput = {true}
          message={this.state.deleteMessage}
          onMessageChange = {this.handleDeleteMessageChange}
          onConfirmButtonText="Remove"
          onCancelButtonText="Cancel"
        />
      </div>
    );
  }
}
